import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, Card, Checkbox, Col, Descriptions, Empty, Flex, Form, Grid, Input, message, Modal, Row, Select, Space, Tag, Typography, Upload, Radio, Switch } from "antd";
import { Link, useNavigate, useParams } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import { complaintService } from "../../services/complaint.service";
import pallete from "../../utils/pallete";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import { Icon } from "@iconify/react/dist/iconify.js";
import { API_BASE_URL } from "../../config/api.config";
import { getFileExtension } from "../../utils/getFileExtension";
import { useEffect, useState } from "react";
import RenderIf from "../../components/RenderIf";
import { canUploadImage } from "../../utils/imageValidator";
import { MAX_FILE_SIZE } from "../../utils/const";
import UploadFileRenderer from "../../components/FileUploadRenderer";

// eslint-disable-next-line react/prop-types
const CardList = ({ title, subtitle, disabled, onChange, checked }) => {
  return (
    <Card
      styles={{
        body: {
          padding: '14px 21px',
          backgroundColor: disabled ? pallete.grey[200] : '#fff'
        }
      }}
    >
      <Space size={'middle'} >
        <Checkbox disabled={disabled} onChange={onChange} checked={checked} />
        <div>
          <Typography.Title level={5} style={{ marginBottom: 4, fontWeight: 500 }} >
            {title}
          </Typography.Title>
          <Typography.Text type="secondary" >
            {subtitle}
          </Typography.Text>
        </div>
      </Space>
    </Card>
  )
}

const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

const preprocessUpload = async (file) => {
  file.preview = await getBase64(file)
  if (!canUploadImage(file.name)) {
    message.error(`Format file tidak benar`);
    return Upload.LIST_IGNORE; // 
  }
  if (file.size > MAX_FILE_SIZE) {
    message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
    return Upload.LIST_IGNORE; // Mencegah upload
  }
}

export default function ComplaintDetail() {

  const navigate = useNavigate()

  const { id } = useParams()

  const { user } = useAuth()

  const [form] = Form.useForm()


  const queryClient = useQueryClient();
  const breakpoint = Grid.useBreakpoint()
  const [modalApi, modalContext] = Modal.useModal()
  const [messageApi, messageContext] = message.useMessage()
  const [initProgress, setInitProgress] = useState(false)

  const [previewImage, setPrevieImage] = useState('')
  const [proggress, setProgress] = useState([])
  const [rejectDocument, setRejectDocument] = useState({
    id: null,
    description: '',
    rejectCategory: '',
    fileList: [],
    empty: true,
  })
  const [finishDocument, setFinishDocument] = useState({
    id: null,
    description: '',
    fileList: [],
    empty: true
  })

  const { data } = useQuery({
    queryKey: [id, 'detail'],
    queryFn: () => complaintService.getById(id),
    enabled: !!id,
    select: ({ data }) => data,
  });

  const { data: status } = useQuery({
    queryKey: [id, 'status'],
    queryFn: () => complaintService.findStatus(id),
    enabled: !!id,
    select: ({ data }) => data,
  });

  useEffect(() => {
    if (status && !initProgress) {

      console.log("sdfs")

      setProgress(
        status
          .filter(e => e.status != 'finish').map(e => ({
            ...e,
            fileList: e.fileList.map(f => ({
              ...f,
              preview: `${API_BASE_URL}/files/${f.path}`
            }))
          }))
      )

      if (status.find(e => e.status == 'reject')) {
        const rejectStatus = status.find(e => e.status == 'reject')
        setRejectDocument({
          ...rejectStatus,
          fileList: rejectStatus.fileList.map(fs => ({
            ...fs,
            preview: `${API_BASE_URL}/files/${fs.path}`
          }))
        })
      }

      if (status.find(e => e.status == 'finish')) {
        const finishStatus = status.find(e => e.status == 'finish')
        setFinishDocument({
          ...finishStatus,
          fileList: finishStatus.fileList.map(fs => ({
            ...fs,
            preview: `${API_BASE_URL}/files/${fs.path}`
          }))
        })
      }
      setInitProgress(true)
    }
  }, [status])

  useEffect(() => {
    if (data) {
      form.setFieldValue('caseId', data.caseId)
      form.setFieldValue('estimatedCompletion', data.estimatedCompletion)
      console.log(data.estimatedCompletion)
    }
  }, [data])

  const changeStatusMutation = useMutation({
    mutationFn: val => complaintService.changeStatus(id, val),
    onSuccess: () => {
      queryClient.invalidateQueries('detail')
      queryClient.invalidateQueries('status')
      messageApi.success("Status berhasil diubah")
    }
  })

  const addProgressMutation = useMutation({
    mutationFn: val => complaintService.addProgress(id, val),
    onSuccess: () => {
      queryClient.invalidateQueries(['status', 'detail'])
      setInitProgress(false)
      messageApi.success("Progress berhasil ditambah")
    }
  })

  const deleteProgressMutation = useMutation({
    mutationFn: deleteId => complaintService.deleteProgress(deleteId),
    onSuccess: () => {
      queryClient.invalidateQueries('status')
      messageApi.success("Progress berhasil dihapus")
    }
  })

  const updateProgressMutation = useMutation({
    mutationFn: (val) => complaintService.updateProgress(val.id, val),
    onSuccess: () => {
      messageApi.success("Progress berhasil disimpan")
    }
  })

  const addFeedbackAttachmentMutation = useMutation({
    mutationFn: ({ proggressId, file }) => complaintService.addFeedbackAttachment(proggressId, { file }),
    onSuccess: ({ data }) => {
      console.log(data)
      messageApi.success("File berhasil ditambah")
    }
  })

  const deleteFeedbackAttachmentMutation = useMutation({
    mutationFn: (fileId) => complaintService.deleteFeedbackAttachment(fileId),
    onSuccess: () => {
      messageApi.success("File berhasil dihapus")
    }
  })

  const updateMutation = useMutation({
    mutationFn: (body) => complaintService.updateFlagging(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries('detail')
      messageApi.success("Status flagging berhasil diubah")
    }
  })

  const handleChangeStatus = status => {
    modalApi.confirm({
      title: 'Pemberitahuan',
      centered: true,
      content: 'Yakin ingin mengubah status pengaduan ?',
      onOk: () => changeStatusMutation.mutate({ status }),
      okButtonProps: {
        loading: changeStatusMutation.isPending
      },
      cancelButtonProps: {
        loading: changeStatusMutation.isPending
      },
    })
  }

  const handleAddProggress = () => {
    setProgress([
      ...proggress,
      {
        fileList: [],
        description: ''
      }
    ])
  }

  const handleAddProgressFile = async (file, index, type = 'process') => {

    if (type == 'process') {
      const selectedProgress = proggress[index]

      if (selectedProgress.id) {
        const { data } = await addFeedbackAttachmentMutation.mutateAsync({ proggressId: selectedProgress.id, file })
        setProgress(prevItems =>
          prevItems.map((item, i) =>
            i === index ? { ...item, fileList: [...(item.fileList ? item.fileList : []), { ...file, id: data.id, name: data.fileName, size: data.fileSize }] } : item
          )
        );
      } else {
        setProgress(prevItems =>
          prevItems.map((item, i) =>
            i === index ? { ...item, fileList: [...(item.fileList ? item.fileList : []), file] } : item
          )
        );
      }
    }

    if (type == 'finish') {
      if (finishDocument.id) {
        const { data } = await addFeedbackAttachmentMutation.mutateAsync({ proggressId: finishDocument.id, file })
        setFinishDocument(prev => ({ ...prev, fileList: [...(prev.fileList ? prev.fileList : []), { ...file, id: data.id, name: data.fileName, size: data.fileSize }] }))
      } else {
        setFinishDocument(prev => ({ ...prev, fileList: [...(prev.fileList ? prev.fileList : []), file] }))
      }
    }

    if (type == 'reject') {
      if (rejectDocument.id) {
        const { data } = await addFeedbackAttachmentMutation.mutateAsync({ proggressId: rejectDocument.id, file })
        setRejectDocument(prev => ({ ...prev, fileList: [...(prev.fileList ? prev.fileList : []), { ...file, id: data.id, name: data.fileName, size: data.fileSize }] }))
      } else {
        setRejectDocument(prev => ({ ...prev, fileList: [...(prev.fileList ? prev.fileList : []), file] }))
      }
    }

  }

  const handleDeleteProgressFile = async (file, progressIndex, type = 'process') => {

    if (type == 'process') {
      const selectedProgress = proggress[progressIndex]
      const selectedFileIndex = selectedProgress.fileList.findIndex(e => e.uid == file.uid)

      const selectedFile = selectedProgress.fileList[selectedFileIndex]

      if (selectedFile.id) {
        await deleteFeedbackAttachmentMutation.mutateAsync(selectedFile.id)
      }

      setProgress(prevItems => {
        const updatedItems = [...prevItems];
        const targetItem = { ...updatedItems[progressIndex] };

        const updatedFileList = [...(targetItem.fileList || [])];
        updatedFileList.splice(selectedFileIndex, 1);

        targetItem.fileList = updatedFileList;
        updatedItems[progressIndex] = targetItem;

        return updatedItems;
      });
    }

    if (type == 'finish') {
      const selectedFile = finishDocument.fileList.find(e => e.uid == file.uid)
      if (selectedFile.id) {
        await deleteFeedbackAttachmentMutation.mutateAsync(selectedFile.id)
      }
      setFinishDocument(prev => ({ ...prev, fileList: prev.fileList.filter(e => e.uid != file.uid) }))
    }

    if (type == 'reject') {
      const selectedFile = rejectDocument.fileList.find(e => e.uid == file.uid)
      if (selectedFile.id) {
        await deleteFeedbackAttachmentMutation.mutateAsync(selectedFile.id)
      }
      setRejectDocument(prev => ({ ...prev, fileList: prev.fileList.filter(e => e.uid != file.uid) }))
    }


  };

  const handleSaveProgress = async (index, type = 'process') => {

    if (type == 'process') {
      const selected = proggress[index]

      if (selected.id) {
        updateProgressMutation.mutate({
          id: selected.id,
          description: selected.description
        })
      } else {
        const { data: resData } = await addProgressMutation.mutateAsync({
          description: selected.description,
          files: selected.fileList,
          status: data?.status
        })
        setProgress(
          prevItems => prevItems.map((e, i) => i == index ? { ...e, id: resData.id } : e)
        )
      }
    }

    if (type == 'finish') {
      if (finishDocument.id) {
        updateProgressMutation.mutate({
          id: finishDocument.id,
          description: finishDocument.description
        })
      } else {
        addProgressMutation.mutate({
          description: finishDocument.description,
          files: finishDocument.fileList,
          status: 'finish'
        })
      }
    }

    if (type == 'reject') {
      if (rejectDocument.id) {
        updateProgressMutation.mutate({
          id: rejectDocument.id,
          description: rejectDocument.description,
          rejectCategory: rejectDocument.rejectCategory
        })
      } else {
        addProgressMutation.mutate({
          description: rejectDocument.description,
          rejectCategory: rejectDocument.rejectCategory,
          files: rejectDocument.fileList,
          status: 'reject'
        })
      }
    }

  }

  const handleDeleteProgress = (index, type = 'process') => {

    let handleOk

    if (type == 'process') {
      const selected = proggress[index]
      handleOk = async () => {
        if (selected?.id) {
          await deleteProgressMutation.mutateAsync(selected?.id)
        }
        setProgress(
          prevItem => prevItem.filter((e, i) => i != index)
        )
      }
    }

    if (type == 'finish') {
      handleOk = async () => {
        if (finishDocument?.id) {
          await deleteProgressMutation.mutateAsync(finishDocument?.id)
        }
        setFinishDocument({
          id: null,
          empty: true,
          fileList: [],
          description: ''
        })
      }
    }

    if (type == 'reject') {
      handleOk = async () => {
        if (rejectDocument?.id) {
          await deleteProgressMutation.mutateAsync(rejectDocument?.id)
        }
        setRejectDocument({
          id: null,
          empty: true,
          fileList: [],
          description: '',
          rejectCategory: ''
        })
      }
    }


    modalApi.confirm({
      title: "Pemberitahuan",
      content: 'Yakin ingin menghapus progress ini ?',
      centered: true,
      onOk: handleOk
    })
  }

  const handleChangeDescription = (value, index) => {
    setProgress((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, description: value } : item
      )
    );
  };

  return (
    <>
      {messageContext}
      {modalContext}
      <Card
        title="Detail Pengaduan Pelanggan"
        style={{ marginBottom: 20 }}
        extra={
          <Flex align="center" gap={8}>
            <Typography.Text>Status Flagging:</Typography.Text>
            <Switch
              checked={data?.flagging || false}
              onChange={(checked) => updateMutation.mutate({ flagging: checked })}
              disabled={!(user?.user?.permissions?.includes('*') || user?.user?.permissions?.includes('Pengaduan')) || updateMutation.isPending}
            />
          </Flex>
        }
      >
        <Typography.Text style={{ color: pallete.grey[600], fontSize: 15, marginBottom: 10, display: 'inline-block' }} >
          Data Diri Pelanggan
        </Typography.Text>
        <Descriptions
          bordered
          size="small"
          column={2}
          style={{ marginBottom: 20 }}
          items={[
            {
              label: 'Nama Lengkap',
              children: data?.name,
              span: 2
            },
            {
              label: 'Email',
              children: data?.email
            },
            {
              label: 'No Handphone',
              children: data?.phone
            },
            {
              label: 'Nomen',
              children: data?.nomen
            },
          ]}
        />
        <Typography.Text style={{ color: pallete.grey[600], fontSize: 15, marginBottom: 10, display: 'inline-block' }} >
          Data Alamat Pelanggan
        </Typography.Text>
        <Descriptions
          bordered
          size="small"
          column={2}
          style={{ marginBottom: 20 }}
          items={[
            {
              label: 'Alamat',
              children: data?.address,
              span: 2
            },
            {
              label: 'Regional',
              children: data?.regional
            },
            {
              label: 'AB',
              children: data?.ab
            },
          ]}
        />
        <Typography.Text style={{ color: pallete.grey[600], fontSize: 15, marginBottom: 10, display: 'inline-block' }} >
          Data Aduan Pelanggan
        </Typography.Text>
        <Descriptions
          bordered
          size="small"
          column={2}
          style={{ borderBottomRightRadius: '0 !important' }}
          className="complaint-desc-top"
          items={[
            {
              label: 'Kategori Pengaduan',
              children: (
                <Flex>
                  {data?.category?.map((e, i) => <Tag key={i} >{e}</Tag>)}
                </Flex>
              )
            },
            {
              label: 'Tanggal Pengaduan',
              children: data?.date
            },
            {
              span: 2,
              label: 'Register ID',
              children: data?.registerId
            },
            {
              label: 'Titik Lokasi',
              children: data?.location,
              span: 2
            },
          ]}
        />
        <RenderIf when={data?.coordinate} >
          <MapContainer
            center={data?.coordinate ? [Number(data?.coordinate?.latitude), Number(data?.coordinate?.longitude)] : [-6.200000, 106.816666]}
            zoom={18}
            style={{ height: '400px', width: '100%' }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker
              position={[Number(data?.coordinate?.latitude), Number(data?.coordinate?.longitude)]}
            />
          </MapContainer>
        </RenderIf>
        <Descriptions
          bordered
          size="small"
          column={1}
          style={{ borderBottomRightRadius: '0 !important' }}
          styles={{ label: { width: 190 } }}
          className="complaint-desc-bottom"
          items={[
            {
              label: 'Deskripsi Pengaduan',
              children: data?.description,
            },
            ...data?.files?.map(
              (e, i) => ({
                label: i == 0 ? 'Dokumen Pendukung' : '',
                children: (
                  <Flex gap={8} align="center" >
                    <Typography.Text style={{ marginRight: 'auto' }}>{e?.fileName}</Typography.Text>
                    <Flex vertical={!breakpoint.lg} gap={8} >
                      <Button
                        icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                        variant="filled"
                        color="primary"
                        size="small"
                        style={{ fontSize: 12 }}
                      >
                        <Link to={e.fileName && `${API_BASE_URL}/files/${e.filePath}`} >
                          Unduh
                        </Link>
                      </Button>
                      <Button
                        variant="filled"
                        color="primary"
                        size="small"
                        style={{ fontSize: 12 }}
                        icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />}
                        onClick={() => setPrevieImage(`${API_BASE_URL}/files/${e.filePath}`)}
                      >
                        Lihat
                      </Button>
                    </Flex>

                  </Flex>
                )
              })
            ) ?? [],
            {
              label: 'Data Source',
              children: data?.source,
            },
          ]}
        />
        <Typography.Text style={{ color: pallete.grey[800], fontSize: 16, marginBottom: 10, marginTop: 20, display: 'inline-block' }} >
          Data Tambahan
        </Typography.Text>
        <Form
          layout="vertical"
          onFinish={updateMutation.mutate}
          form={form}
        >
          <Row gutter={[20]} >
            <Col span={12} >
              <Form.Item
                label="Case ID"
                name={'caseId'}
                rules={[{ required: true }]}
              >
                <Input disabled={data?.caseId} />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item
                label="Estimasi Pengerjaan"
                name={'estimatedCompletion'}
                rules={[{ required: true }]}
              >
                <Input type="date" />
              </Form.Item>
            </Col>
            <Col span={24} >
              <Flex justify="flex-end" gap={12} >
                <Button variant="outlined" color="primary" onClick={() => navigate(-1)} >
                  Kembali
                </Button>
                <Button htmlType="submit" variant="solid" color="primary" >
                  Simpan
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </Card>
      <Card
        title="Status Update"
      >
        <Space direction="vertical" size={"middle"} style={{ width: '100%' }} >
          <CardList
            title={'Laporan Diterima'}
            subtitle={'Pelaporan Diterima'}
            disabled={true}
            checked={true}
          />
          <CardList
            title={'Laporan Diproses'}
            subtitle={'Progress Pelaporan'}
            onChange={() => handleChangeStatus('process')}
            disabled={data?.status == 'reject'}
            checked={data?.status == 'process'}
          />
          <RenderIf when={data?.status == 'process'} >
            <div style={{ padding: '10px 0' }} >
              <RenderIf when={proggress.length == 0 && !data?.isFinish} >
                <Empty>
                  <Button onClick={handleAddProggress} variant="outlined" color="primary" >
                    Tambah Progress
                  </Button>
                </Empty>
              </RenderIf>
              <RenderIf when={proggress.length > 0} >
                {
                  proggress.map((e, idx) => (
                    <div key={idx.toString()} style={{ marginBottom: 20 }} >
                      <Typography.Text style={{ display: 'inline-block', marginBottom: 20 }} >
                        Progress Pelaporan - {idx + 1}
                      </Typography.Text>
                      <Upload
                        style={{ width: '100%', display: 'block' }}
                        rootClassName="survey-upload"
                        disabled={data?.isFinish}
                        beforeUpload={async (file) => {
                          await preprocessUpload(file)
                          handleAddProgressFile(file, idx)
                          return false
                        }}
                        fileList={e?.fileList}
                        onRemove={(file) => {
                          handleDeleteProgressFile(file, idx)
                        }}
                        itemRender={(_, file, filelist, action) => (
                          <UploadFileRenderer
                            file={file}
                            action={action}
                            onPreview={() => setPrevieImage(file.preview)}
                          />
                        )}
                      >
                        <Flex justify="space-between" >
                          <div style={{ flex: 1 }} >
                            <Typography.Text style={{ display: 'block' }} >
                              <Typography.Text style={{ color: 'red', marginRight: 6 }} >
                                *
                              </Typography.Text>
                              Dokumen Pendukung
                            </Typography.Text>
                            <Typography.Text type="secondary" style={{ paddingLeft: 11 }} >
                              File jpeg, png, jpg, Max. file size: 2 MB
                            </Typography.Text>
                          </div>
                          <Button
                            icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                            disabled={data?.isFinish || proggress[idx].id}
                          >
                            Upload
                          </Button>
                        </Flex>
                        <RenderIf when={false} >
                          <Typography.Text type="danger" style={{ display: 'block', marginTop: 10 }} >
                            File tidak boleh kosong
                          </Typography.Text>
                        </RenderIf>
                      </Upload>
                      <Form.Item
                        label="Deskripsi Progress"
                        layout="vertical"
                        style={{ marginTop: 20 }}
                      >
                        <Input.TextArea disabled={proggress[idx].id} value={proggress[idx]?.description} onChange={e => handleChangeDescription(e.target.value, idx)} rows={5} />
                      </Form.Item>
                      <Flex gap={8} >
                        {/* <RenderIf when={!data?.isFinish} >
                          <Button loading={addProgressMutation.isPending || updateProgressMutation.isPending} disabled={data?.isFinish} onClick={() => handleDeleteProgress(idx)} variant="solid" color="danger" >
                            Hapus
                          </Button>
                        </RenderIf> */}
                        <RenderIf when={!data?.isFinish} >
                          <Button loading={addProgressMutation.isPending || updateProgressMutation.isPending} disabled={!proggress[idx].description || proggress[idx].id} onClick={() => handleSaveProgress(idx)} variant="solid" color="primary" >
                            Simpan
                          </Button>
                        </RenderIf>
                        <RenderIf when={(proggress.length - 1) == idx && !data?.isFinish} >
                          <Button style={{ marginLeft: 'auto' }} disabled={!proggress[idx].description || !proggress[idx].id} onClick={handleAddProggress} variant="solid" color="primary" >
                            Tambah Progress
                          </Button>
                        </RenderIf>
                      </Flex>
                    </div>
                  ))
                }
              </RenderIf>
            </div>
          </RenderIf>
          <CardList
            title={'Laporan Ditolak'}
            subtitle={'Progress Pelaporan'}
            onChange={() => handleChangeStatus('reject')}
            disabled={data?.status == 'process'}
            checked={data?.status == 'reject'}
          />
          <RenderIf when={data?.status == 'reject'} >
            <div style={{ padding: '10px 0' }} >
              <RenderIf when={rejectDocument.empty} >
                <Empty>
                  <Button onClick={() => setRejectDocument({ ...rejectDocument, empty: false })} variant="outlined" color="primary" >
                    Tambah Progress
                  </Button>
                </Empty>
              </RenderIf>
              <RenderIf when={!rejectDocument.empty} >
                <div style={{ marginBottom: 20 }} >
                  <Upload
                    disabled={data?.isFinish && data?.status == 'reject' && rejectDocument?.id}
                    style={{ width: '100%', display: 'block' }}
                    rootClassName="survey-upload"
                    beforeUpload={async (file) => {
                      await preprocessUpload(file)
                      handleAddProgressFile(file, 0, 'reject')
                      return false
                    }}
                    fileList={rejectDocument?.fileList}
                    onRemove={(file) => {
                      handleDeleteProgressFile(file, 0, 'reject')
                    }}
                    itemRender={(_, file, filelist, action) => (
                      <UploadFileRenderer
                        file={file}
                        action={action}
                        onPreview={() => setPrevieImage(file.preview)}
                      />
                    )}
                  >
                    <Flex justify="space-between" >
                      <div style={{ flex: 1 }} >
                        <Typography.Text style={{ display: 'block' }} >
                          <Typography.Text style={{ color: 'red', marginRight: 6 }} >
                            *
                          </Typography.Text>
                          Dokumen Pendukung
                        </Typography.Text>
                        <Typography.Text type="secondary" style={{ paddingLeft: 11 }} >
                          File jpeg, png, jpg, Max. file size: 2 MB
                        </Typography.Text>
                      </div>
                      <Button
                        icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
                        disabled={data?.isFinish && data?.status == 'reject' && rejectDocument?.id}
                      >
                        Upload
                      </Button>
                    </Flex>
                    <RenderIf when={false} >
                      <Typography.Text type="danger" style={{ display: 'block', marginTop: 10 }} >
                        File tidak boleh kosong
                      </Typography.Text>
                    </RenderIf>
                  </Upload>
                  <Form.Item
                    label="Kategori Penolakan"
                    layout="vertical"
                    style={{ marginTop: 20 }}
                  >
                    <Select
                      value={rejectDocument.rejectCategory}
                      options={['Penolakan 1', 'Penolakan 2'].map(e => ({ label: e, value: e }))}
                      onChange={e => setRejectDocument({ ...rejectDocument, rejectCategory: e })}
                      disabled={data?.isFinish && data?.status == 'reject' && rejectDocument?.id}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Alasan Penolakan"
                    layout="vertical"
                    style={{ marginTop: 20 }}
                  >
                    <Input.TextArea disabled={data?.isFinish && data?.status == 'reject' && rejectDocument?.id} value={rejectDocument?.description} onChange={e => setRejectDocument({ ...rejectDocument, description: e.target.value })} rows={5} />
                  </Form.Item>
                  <RenderIf when={!rejectDocument?.id} >
                    <Flex gap={8} >
                      <Button onClick={() => handleDeleteProgress(0, 'reject')} variant="solid" color="danger" >
                        Hapus
                      </Button>
                      <Button disabled={!rejectDocument.description || addProgressMutation.isPending} loading={addProgressMutation.isPending} onClick={() => handleSaveProgress(0, 'reject')} variant="solid" color="primary" >
                        Simpan
                      </Button>
                    </Flex>
                  </RenderIf>
                </div>
              </RenderIf>
            </div>
          </RenderIf>
          <CardList
            title={'Laporan Selesai'}
            subtitle={'Pelaporan Telah Diselesaikan'}
            onChange={() => handleChangeStatus('finish')}
            checked={data?.isFinish}
            disabled={data?.isFinish}
          />
        </Space>
      </Card>
      <Flex justify="flex-start" style={{ marginTop: 10 }} >
        <Button onClick={() => navigate(-1)} variant="outlined" color="primary" >
          Kembali
        </Button>
      </Flex>
      <Modal
        open={previewImage.length > 0}
        centered
        title="Gambar"
        onCancel={() => setPrevieImage('')}
        footer={[
          <Button variant="outlined" color="primary" key="cancel" onClick={() => setPrevieImage('')}>
            Cancel
          </Button>
        ]}
      >
        <embed style={{ width: '100%', height: getFileExtension(previewImage) == 'pdf' && '500px' }} src={previewImage} />
      </Modal>
    </>
  )
}